import {
  createExamModuleDb,
  examModuleWriteSchema,
  FirestoreTimestamp,
  type ExamModule,
  type ExamModuleWrite,
} from '@cp/model';
import {serverTimestamp, setDoc} from 'firebase/firestore';
import convertStringKebabCase from '../../utils/string/convertStringKebabCase';
import getExamModuleDoc from './getExamModuleDoc';
import getExamModuleDocRef from './getExamModuleDocRef';

export default async function createExamModuleDoc(input: ExamModuleWrite): Promise<ExamModule> {
  const parsed = examModuleWriteSchema.parse(input);
  const ref = getExamModuleDocRef(convertStringKebabCase(input.name));
  await setDoc(ref, createExamModuleDb(parsed, serverTimestamp() as unknown as FirestoreTimestamp));
  const module = await getExamModuleDoc(ref.id);
  if (!module) throw new Error('Exam module not found after create');
  return module;
}
